import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  list(parameters={}) {
    return core.call({
      url: '/api/v1/popup/list',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  detail(parameters={}) {
    return core.call({
      url: '/api/v1/popup/detail',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
  postSearch(parameters={}) {
    return core.call({
      url: '/api/v1/external/post',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    }); 
  },
}

